import type { ReactNode } from "react";
import { Button } from "@/components/ui/button";
import { m } from "@/paraglide/messages";

export interface TimerControlsProps {
  running: boolean;
  onStart: () => void;
  onPause: () => void;
  onReset: () => void;
  /** Optional extra control (e.g. the stopwatch "Lap" button). */
  extra?: ReactNode;
}

/** Start/Pause toggle + Reset, with an optional extra action. */
export function TimerControls({
  running,
  onStart,
  onPause,
  onReset,
  extra,
}: TimerControlsProps) {
  return (
    <div className="flex flex-wrap items-center justify-center gap-3">
      {running ? (
        <Button size="lg" onClick={onPause} className="min-w-28">
          {m.timer_pause()}
        </Button>
      ) : (
        <Button size="lg" onClick={onStart} className="min-w-28">
          {m.timer_start()}
        </Button>
      )}
      {extra}
      <Button
        size="lg"
        variant="outline"
        onClick={onReset}
        className="min-w-28"
      >
        {m.timer_reset()}
      </Button>
    </div>
  );
}
